document.addEventListener("DOMContentLoaded", function() {

	const $ = jQuery.noConflict(),
			win = $(window),
			body_height = $('body .wp-site-blocks').height(),
			win_height = win.height(),
			pageUrl = window.location.href;

	/**
	 * Megamenu
	 */
	function megaFunction() {

		if (win.width() > 1024) {

			$('nav.header-nav.megamenu #menu-item-35755').bind("mouseover mouseenter", function(e) {
				$('.menu-item').removeClass('active');
				$('.megamenus.post-35726, .header-nav-overlay, #menu-item-35755').addClass('active');
				$('.header-nav-overlay').css('height',body_height - win_height);
			});

			$('nav.header-nav.megamenu #menu-item-35694').bind("mouseover mouseenter", function(e) {
				$('.menu-item').removeClass('active');
				$('.megamenus.post-36267, .header-nav-overlay, #menu-item-35694').addClass('active');
				$('.header-nav-overlay').css('height',body_height - win_height);
			});

			$('nav.header-nav.megamenu #menu-item-35695').bind("mouseover mouseenter", function(e) {
				$('.menu-item').removeClass('active');
				$('.megamenus.post-36292, .header-nav-overlay, #menu-item-35695').addClass('active');
				$('.header-nav-overlay').css('height',body_height - win_height);
			});

		} else {
			$('.wp-block-post.megamenus, .header-nav-overlay, .menu-item').removeClass('active');
		}

		$('#menu-header-menu .menu-item:not(.active) a, .header-nav-overlay, .logorow').bind("mouseover mouseenter", function(e) {
			$('.wp-block-post.megamenus, .header-nav-overlay, .menu-item').removeClass('active');
		});

		$('#menu-header-menu .wp-block-post.megamenus, .header-nav-overlay').on('click', function() {
			$('.wp-block-post.megamenus, .header-nav-overlay, .menu-item').removeClass('active');
		});
	}

	if (win.width() > 1024) {
		megaFunction();		
	} else {
		$('.wp-block-post.megamenus, .header-nav-overlay, .menu-item').removeClass('active');
	}

	window.addEventListener('resize', function() {
		if ( win.innerWidth < 1024 ) {
			$('.wp-block-post.megamenus, .header-nav-overlay, .menu-item').removeClass('active mega-dektop');
		} else {
			megaFunction();				
		}
	});

	function isTouchDevice(){
		return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
	}

	// Reload on resize Desktop
	if(isTouchDevice()===false) {
		$(window).bind('resize', function(e) {
			if (window.RT) clearTimeout(window.RT);
			window.RT = setTimeout(function() {
				this.location.reload(false); /* false to get page from cache */
			}, 100);
		});
	}

	$('.wpcf7-select, .acf-form select').select2( { minimumResultsForSearch: 20 } );

    /**
	 * Mobile Menu Toggle
	 */
	if ($("body").hasClass("menu-open")) {
		$('body').removeClass("menu-open");
	} else {
		$('body').toggleClass("menu-open");
	}

	$('body').removeClass("menu-open");


	$('.header-nav-overlay').on('click', function() {
		$('body').removeClass("menu-open");
	});

	$('.wp-header-menu-container .navbar-nav>.menu-item a').each(function() {
		const target = $(this).attr('href');
		if( pageUrl === target ) {
			$(this).parent('.nav-item').addClass('menu-item-current');
		} else {
			$(this).parent('.nav-item').removeClass('menu-item-current');
		}
	});

    	/**
	 * Switcher Dark Mode
	 */
	const darkTheme = "dark-theme";
	const darkThemeSetUp = () => {
		if (getCurrentTheme() === "dark") {
			document.getElementById("toggleBtn").checked = true;
		} else {
			document.getElementById("toggleBtn").checked = false;
		}
	};
	const getCurrentTheme = () => document.body.classList.contains(darkTheme) ? "dark" : "light";
	const selectedTheme = localStorage.getItem("selected-theme");
	if (selectedTheme === "dark") {
		document.body.classList[selectedTheme === "dark" ? "add" : "remove"](
			darkTheme
		);
		darkThemeSetUp();
	}
	const themeButton = document.getElementById("toggleBtn");

	if ($("body").hasClass("light-dark")) {
		// console.log('btn active');
		$(".switcher-darkmode").css("display","block");

		themeButton.addEventListener("change", () => {
			document.body.classList.toggle(darkTheme);
			localStorage.setItem("selected-theme", getCurrentTheme());
			darkThemeSetUp();
		});
		
	} else {
		// console.log('btn not active');
		$(".switcher-darkmode").css("display","none");
	}

	if ($("body").hasClass("wp-search")) {
		$(".top-searchbox").css("display","block");
	} else {
		$(".top-searchbox").css("display","none");
	}

	/**
	 * Switching Cart
	 */
	if ($("body").hasClass("woo-cart")) {
		$(".wp-block-woocommerce-mini-cart").css({"display":"flex","opacity":"1"});
	}
	else {
		$(".wp-block-woocommerce-mini-cart").css("display","none");
	}

	/**
	 * Switching Account Btn
	 */
	if ($("body").hasClass("woo-account")) {
		$(".block-account").css({"display":"flex","opacity":"1"});
	}
	else {
		$(".block-account").css("display","none");
	}

	/**
	 * Switching Flags Btn
	 */
	if ($("body").hasClass("menu-flags")) {
		$(".block-polylang").css({"display":"flex","opacity":"1"});
	}
	else {
		$(".block-polylang").css("display","none");
	}

	if ( $("body nav.header-nav").hasClass("megamenu") ) { 
		$(".navbar-toggler-btn").css({"display":"none"});
	} else {
		$(".navbar-toggler-btn").css({"display":"block"});
	}
    
});